<template>
    <section class="current_room_edit">
        <div class="comp_scroller">
            <div class="comp_content" :class="{'state-loading':!data}">
                <template v-if="data">
                    <template v-if="data.guests.length === 0 || !data.roomingComplete">
                        <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle"
                                style="margin-bottom: 20px">
                            <div class="col">
                                <h1 class="part_ui_heading"><span>{{ data.name }}</span></h1>
                            </div>
                        </header>
                        <div
                            style="border-radius: 5px;background: white;border: 1px solid #C5D5DA;display:flex;padding: 15px;gap: 10px">
                            <span class="icon icon--exclamation-triangle-fill" style="font-size: 2rem;color:#ffd200"/>
                            <div style="display:flex;flex-direction: column;gap:10px">
                                <div style="margin-top: -6px;">{{ $t('no_rooming_checkin') }}</div>
                                <a style="color: #0099FF;cursor: pointer"
                                   v-on:click="$router.push(`/bookings/edit/${id}/${row}`)">{{
                                        $t('edit_reservation') + ' ' + id
                                    }}</a>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="selectedRoomId === undefined">
                        <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle"
                                style="margin-bottom: 20px">
                            <div class="col">
                                <h1 class="part_ui_heading"><span>{{ data.name }}</span></h1>
                                <a style="color: #0099FF;cursor: pointer;margin-bottom: 10px"
                                   v-on:click="$router.push(`/bookings/edit/${id}/${row}`)">{{
                                        $t('edit_reservation') + ' ' + id
                                    }}</a>
                            </div>
                        </header>
                        <div v-for="room in roomsList">
                            <div :class="`elm_item room ${room.checkedIn ? 'checked-in':''}`"
                                 style="cursor: pointer"
                                 v-on:click="$router.push(`/overview/arrivals/${id}/${row}/${room.id}`)">
                                <div
                                    :class="`mod--row mod--row-flex mod--row-middle`">
                                    <div class="col col--6" style="align-items: flex-start">
                                        <div class="content"
                                             style="gap: 10px;display:flex;flex-direction: row;align-items: center">
                                            <room-label :label="room.code" :disabled="room.checkedIn"/>
                                            <div style="font-weight: 500">{{ room.type.code }}</div>
                                            <span class="icon icon--person-check-fill" v-if="room.complete"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle"
                                v-if="subScreen !== 'guest' && subScreen !== 'account'">
                            <div class="col">
                                <h1 class="part_ui_heading"><span>{{ data.name }}</span></h1>
                                <a style="color: #0099FF;cursor: pointer;margin-bottom: 10px"
                                   v-on:click="$router.push(`/bookings/edit/${id}/${row}`)">{{
                                        $t('edit_reservation') + ' ' + id
                                    }}</a>
                            </div>
                        </header>
                        <div class="wrp_comp_body" v-on:scroll="handleGlobalScroll($event)" v-if="!subScreen">
                            <div class="info-row">
                                <div class="cell" v-if="currentRoom && currentRoomType">
                                    <div class="content" style="gap: 10px">
                                        <room-label :label="currentRoom.code"/>
                                        <div style="font-weight: 500">{{ currentRoomType.code }}</div>
                                    </div>
                                </div>
                                <div class="cell">
                                    <div class="content">
                                        <span>{{ currentRoomGuests.length }}x&nbsp;</span>
                                        <span class="icon icon--person-fill" style="font-size: 22px;margin-top: -6px"/>
                                        <span v-if="data.isGroup">({{ $t('group') }})</span>
                                    </div>
                                </div>
                                <div class="cell">
                                    <div class="content">
                                        <span>{{ data.nightsCount }}x&nbsp;</span>
                                        <span class="icon icon--moon-fill" style="font-size: 14px;margin-top: -2px"/>
                                    </div>
                                </div>
                            </div>
                            <div class="guests">
                                <div v-for="(guest, index) in currentRoomGuests">
                                    <div class="guest"
                                         v-on:click="$router.push(`/overview/arrivals/${id}/${row}/${selectedRoomId}/guest/${index}`)">
                                        <div class="name">{{ guest.profile.full_name }}</div>
                                        <div class="master" v-if="index===0">({{ $t('master') }})</div>
                                        <div class="arrow"><span class="icon icon--chevron-right"/></div>
                                    </div>
                                </div>
                            </div>

                            <div class="items">
                                <edit-item :label="$t('source')"
                                           labelFor="source-id">
                                    <div class="part_ui_select">
                                        <custom-search-select
                                            id="source-id"
                                            v-model="data.sourceId"
                                            :options="selectSources"
                                            :id-func="o=>o.id"
                                            :label-func="o=>`${o.name} (${ o.code })`"/>
                                    </div>
                                </edit-item>
                                <edit-item :label="$t('arrival')"
                                           labelFor="check-in-date">
                                    <div class="part_ui_input">
                                        <date-input v-model="data.checkInDate"
                                                    v-on:input="getSelectRoomNumbers()" required
                                                    disabled/>
                                    </div>
                                </edit-item>
                                <edit-item :label="$t('departure')"
                                           labelFor="check-out-date">
                                    <div class="part_ui_input">
                                        <date-input v-model="data.checkOutDate"
                                                    disabled
                                                    v-on:input="getSelectRoomNumbers()" required/>
                                    </div>
                                </edit-item>
                                <edit-item :label="$t('room_type')">
                                    <div class="part_ui_select">
                                        <custom-search-select
                                            v-model="data.roomTypeId"
                                            @input="getSelectRoomNumbers();data.roomId = undefined"
                                            :options="selectRoomTypes"
                                            :id-func="o=>o.id"
                                            :label-func="o=>`${o.description} (${ o.code })`"/>
                                    </div>
                                </edit-item>
                                <edit-item :label="$t('room_number')">
                                    <div class="part_ui_select room_select">
                                        <custom-search-select
                                            :value="data.roomId"
                                            v-on:input="changeRoom($event)"
                                            :options="this.selectRoomNumbers"
                                            :id-func="o=>o.id"
                                            :label-func="o=>o.code"/>
                                    </div>
                                </edit-item>
                                <edit-item :label="$t('pricelist')"
                                           labelFor="price-list-id">
                                    <div class="part_ui_select disabled">
                                        <custom-search-select
                                            id="price-list-id"
                                            v-model="data.priceListId"
                                            disabled
                                            :options="selectPriceLists"
                                            :id-func="o=>o.id"
                                            :label-func="o=>o.name"/>
                                    </div>
                                </edit-item>
                                <edit-item :label="$t('price_type')"
                                           labelFor="price-type-id">
                                    <div class="part_ui_select disabled">
                                        <custom-search-select
                                            id="price-type-id"
                                            v-model="data.priceTypeId"
                                            disabled
                                            :options="selectPriceTypes"
                                            :id-func="o=>o.id"
                                            :label-func="o=>o.code"/>
                                    </div>
                                </edit-item>
                                <edit-item :label="$t('price_mask')"
                                           class="clickable"
                                           v-on:click="$router.push(`/overview/arrivals/${id}/${row}/${selectedRoomId}/priceMask`)">
                                    <div class="part_ui_input">
                                        <input id="price-mask-text" :value="priceMaskText" type="text" readonly>
                                    </div>
                                </edit-item>
                                <div style="padding: 12px 0">
                                    <edit-item :label="$t('price_per_day')" class="naked">
                                        <div>{{ (data.total_price_per_room / data.nightsCount).toFixed(2) }}
                                            {{ this.currency }}
                                        </div>
                                    </edit-item>
                                    <edit-item :label="$t('price_total')" class="naked">
                                        <div>{{ data.total_price_per_room }} {{ this.currency }}</div>
                                    </edit-item>
                                </div>
                                <edit-item :label="$t('note')" labelFor="note" style="margin-top: 27px">
                                    <div class="part_ui_input part_ui_textarea">
                                    <textarea type="date" id="note" v-model="data.note" ref="note"
                                              style="text-align: right"
                                              v-autosize="data.note"/>
                                    </div>
                                </edit-item>
                            </div>

                            <div>
                                <div class="elm_button">
                                    <button class="part_ui_btn part_ui_btn_primary mod--block"
                                            v-on:click="checkin()"
                                            :disabled="!this.data.roomId || this.data.guests.some(g=>g.room_id === this.data.roomId && g.checked_in)">
                                        {{ $t('create_checkin') }}
                                    </button>
                                </div>
                                <div style="display:flex;justify-content: center;margin-top: 10px">
                                    <div v-if="!this.data.roomId"
                                         style="display:flex; gap:5px; font-size: 10px;max-width: 300px">
                                        <i class="icon icon--info-circle-fill" style="color: #0099FF;font-size: 18px"/>
                                        <span v-html="$t('checkin_disabled_message')"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else-if="subScreen === 'priceMask'">
                            <price-mask-edit
                                :price-mask-map="data.priceMask"
                                :from="data.checkInDate"
                                :to="data.checkOutDate"
                                :on-close="()=>$router.back()"/>
                        </div>

                        <guest-profile-detail v-else-if="subScreen==='guest'"
                                              :profile="currentRoomGuests[Number(subScreenItemId)].profile"
                                              :note="currentRoomGuests[Number(subScreenItemId)].note"/>
                    </template>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment/moment';
import {computePriceMaskText, priceMaskArrayToMap} from '../../main';
import PriceMaskEdit from '../part/price-mask-edit.vue';

export default {
    components: {PriceMaskEdit},
    name: 'checkin-edit',
    data() {
        return {
            selectedRoomId: undefined,
            roomsIds: [],
            moment: moment,
            id: null,
            row: null,
            data: undefined,
            selectSources: [],
            selectRoomTypes: [],
            selectRoomNumbers: [],
            currentRoom: undefined,
            currentRoomType: undefined,
            selectPriceTypes: [],
            selectPriceLists: [],
            selectPriceMasks: [],
            subScreen: undefined,
            subScreenItemId: undefined,
            priceMaskText: '',
            priceMask: [],
            currency: null,
            account: undefined,
            currentRoomGuests: [],
            roomsList: []
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.row = this.$route.params.row;

        Promise.all([
            this.getSelectPriceTypes(),
            this.getSelectSources(),
            this.getSelectRoomTypes()
        ]).then(async () => {
            await this.loadData()
        })

        this.parseRoute()
    },
    watch: {
        'data.priceListId': function () {
            this.getPriceTypes();

            const priceList = this.selectPriceLists.find(l => l.id === this.data.priceListId)
            if (priceList) {
                this.currency = priceList.accommodation_currency.code_iso
            }
        },
        'data.priceMask': function () {
            this.computePriceMaskText()
        },
        $route: function () {
            this.parseRoute()
            this.updateCurrentRoomGuests()
        },
        selectRoomNumbers: function () {
            this.updateCurrentRoom()
            this.updateRoomsList()
        },
        'data.roomId': function () {
            this.updateCurrentRoom()
        },
        selectRoomTypes: function () {
            this.updateCurrentRoomType()
            this.updateRoomsList()
        },
        'data.roomTypeId': function () {
            this.updateCurrentRoomType()
        },
        'data.guests': function () {
            this.updateCurrentRoomGuests()
        },
        selectedRoomId: function () {
            if (this.data) {
                this.data.roomId = this.selectedRoomId
            }
        },
        roomsIds: function () {
            this.updateRoomsList()
        },
        currency: function () {
            this.computePriceMaskText()
        }
    },
    methods: {
        updateCurrentRoom() {
            if (this.selectRoomNumbers && this.data) {
                this.currentRoom = this.selectRoomNumbers.find(r => r.id === this.data.roomId)
            }
        },
        updateCurrentRoomType() {
            if (this.selectRoomTypes && this.data) {
                this.currentRoomType = this.selectRoomTypes.find(r => r.id === this.data.roomTypeId)
            }
        },
        updateRoomsList() {
            if (this.roomsIds && this.selectRoomNumbers && this.selectRoomTypes) {
                this.roomsList = this.roomsIds.map(id => {
                    const room = this.selectRoomNumbers.find(r => r.id === id)
                    if (room) {
                        const type = this.selectRoomTypes.find(t => t.code === room.room_type_code)
                        if (type) {
                            return Object.assign({
                                type,
                                checkedIn: this.data.guests.some(g => g.room_id === room.id && g.checked_in),
                                complete: this.data.guests.every(g => g.room_id === room.id && g.profile.is_complete)
                            }, room)
                        }
                    }
                    return undefined;
                }).filter(i => i)
            } else {
                this.roomsList = []
            }
        },
        updateCurrentRoomGuests() {
            if (this.data && this.data.guests) {
                if (this.selectedRoomId) {
                    this.currentRoomGuests = this.data.guests.filter(g => g.room_id === this.selectedRoomId)
                } else {
                    this.currentRoomGuests = this.data.guests
                }
            }
        },
        changeRoom(roomId) {
            this.data.roomId = roomId
        },
        changeRoomType(roomTypeId) {
            this.data.roomTypeId = roomTypeId
        },
        parseRoute() {
            this.subScreen = this.$route.params.subScreen;
            this.subScreenItemId = this.$route.params.subScreenItemId;

            if (this.roomsIds.length > 1) {
                this.selectedRoomId = this.$route.params.roomId ? Number(this.$route.params.roomId) : undefined;
            }
        },
        changePrice(event, index) {
            let pm = [...this.data.priceMask];
            pm[index].price = event.target.value;

            this.data.priceMask = pm;
            this.computePriceMaskText();
        },
        async loadData() {
            let query = `{
              getReservation(reservation_number: ${this.id}) {
                id
                name
                source_id
                is_group
                name
                note
                reservation_rows {
                    id
                    check_in_date
                    check_out_date
                    room_type_id
                    room_count
                    guest_count
                    pricelist_id
                    pricetype_id
                    total_price_per_room
                    nights
                    guests {
                      id
                      room_id
                      checked_in
                      profile {
                        id
                        full_name
                        first_name
                        last_name
                        email_address
                        phone_number
                        address_street
                        address_zip
                        address_town
                        address_hn
                        country_id
                        note
                        citizenship_id
                        ic_number
                        birth_date
                        birth_town
                        licence_plate
                        is_complete
                      }
                    }
                    prices {
                        date
                        price
                    }
                }
                accommodation_currency {
                    code_iso
                }
              }
            }`;

            await axios({
                data: query
            }).then(async (response) => {
                let res = response.data.data.getReservation;

                this.currency = res.accommodation_currency.code_iso

                const row = res.reservation_rows.find(r => parseInt(r.id) === parseInt(this.row));

                this.roomsIds = [...new Set(res.reservation_rows.flatMap(r => r.guests).map(g => g.room_id).filter(i => i))]

                if (this.roomsIds.length === 1) {
                    this.selectedRoomId = this.roomsIds[0]
                } else if (this.roomsIds.length === 0) {
                    this.selectedRoomId = null
                }

                // TODO vyhodit chybu při nenalezeném row

                this.data = {
                    id: res.id,
                    name: res.name,
                    isGroup: res.is_group,
                    sourceId: res.source_id,
                    nightsCount: row.nights,
                    roomId: this.selectedRoomId,
                    roomTypeId: row.room_type_id,
                    guests: row.guests,
                    checkInDate: moment(row.check_in_date).toDate(),
                    checkOutDate: moment(row.check_out_date).toDate(),
                    priceListId: row.pricelist_id,
                    priceTypeId: row.pricetype_id,
                    roomingComplete: row.guests.every(g => g.room_id),

                    note: res.note ? res.note : '',
                    priceMask: priceMaskArrayToMap(row.prices),
                    total_price_per_room: row.total_price_per_room
                }

                this.computePriceMaskText();
                await this.getSelectRoomNumbers();
            }).catch(error => {
                this.showError(error)
            });
        },
        getSelectSources: async function () {
            await axios({
                data: `{
                        listReservationSources {
                          id
                          code
                          name
                        }
                      }`
            }).then(response => {
                this.selectSources = response.data.data.listReservationSources;
            }).catch(error => {
                this.showError(error)
            });
        },
        getSelectRoomTypes: function () {
            return axios({
                data: `{
                        listRoomTypes {
                          id
                          code
                          description
                        }
                      }`
            }).then(response => {
                this.selectRoomTypes = response.data.data.listRoomTypes;
            }).catch(error => {
                this.showError(error)
            });
        },
        getSelectPriceTypes: async function () {
            await axios({
                data: `{
                        listPriceLists(deleted: false) {
                          id
                          name
                          price_types {
                            id
                            code
                          }
                        }
                      }`
            }).then(response => {
                this.selectPriceLists = response.data.data.listPriceLists;

                let priceTypes = [];

                response.data.data.listPriceLists.forEach(function (item) {
                    item.price_types.forEach(function (itm) {
                        itm.pricelist_id = item.id;
                        priceTypes.push(itm);
                    });
                });

                this.selectPriceTypesAll = priceTypes;
            }).catch(error => {
                this.showError(error)
            });
        },
        getSelectRoomNumbers: function () {
            const query = `{
                    listAvailableRooms(free_from: "${moment(this.data.checkInDate).format('YYYY-MM-DD')}",
                    free_to: "${moment(this.data.checkOutDate).format('YYYY-MM-DD')}",
                    room_type_id: ${this.data.roomTypeId},
                    available_only: true,
                    filter_reservation_number: ${this.id})
                    {
                        id
                        code
                        room_type_code
                    }
                }`

            return axios({
                data: query
            }).then(response => {
                this.selectRoomNumbers = response.data.data.listAvailableRooms;
            }).catch(error => {
                this.showError(error)
            });
        },
        getPriceTypes() {
            let selectPriceTypes = [];

            const priceListId = this.data.priceListId;

            if (priceListId) {
                this.selectPriceTypesAll.forEach(function (item) {
                    if (parseInt(item.pricelist_id) === parseInt(priceListId)) {
                        selectPriceTypes.push(item);
                    }
                });
            }

            this.selectPriceTypes = selectPriceTypes;
        },
        computePriceMaskText() {
            this.priceMaskText = computePriceMaskText(this.data.priceMask, this.currency)
        },
        async checkin() {
            const {$router} = this

            const {roomId, sourceId} = this.data

            const guests = this.currentRoomGuests
                .map(g => {
                    return `{
                  reservation_id: ${this.row}
                  reservation_guests_id: ${g.id}
                  profile: {
                    id: ${g.profile.id}
                    last_name: "${g.profile.last_name}"
                  }
                }`
                }).join(',')

            await axios({
                data: `mutation {
                      checkIn(reservation_number: ${this.id}, current_rooms: [
                        {
                          room_id: ${roomId}
                          current_guests: [${guests}]
                          reservation_source_id: ${sourceId}
                        }
                      ]) {
                        ok
                      }
                    }`
            }).then(res => {
                if (res.data.data.checkIn.ok) {
                    const self = this
                    this.$dialog.alert(this.$t('checkin_done'), {okText: this.$t('ok')}).then(async function (dialog) {
                        await self.loadData()
                        if (self.data.guests.every(g => g.checked_in)) {
                            $router.push(`/overview/arrivals`)
                        } else {
                            $router.back()
                        }
                    });
                } else {
                    this.$dialog.alert(this.$t('unknown_error'), {okText: this.$t('ok')});
                }
            }).catch(error => {
                this.showError(error)
            });
        },
    }
}
</script>

<style scoped lang="less">
@import "../../less/_core/global/font_sizes.less";
@import "../../less/_core/theme/core/colors.less";

header {
    margin-bottom: 2px;
}

.comp_content {
    min-height: 100%; // TODO kvůli loadingu. asi pryč?
    display: flex;
    flex-direction: column;
}

.info-row {
    display: flex;
    margin-bottom: 10px;
    gap: 15px;

    .cell {
        display: flex;
        flex: 1;
        justify-content: flex-start;

        .content {
            display: flex;
            align-items: center;
            flex: 1;
        }
    }
}

.guests {
    margin-bottom: 20px;

    .guest {
        display: flex;
        align-items: baseline;
        padding: 12px 0 8px 0;
        border-bottom: 1px solid @color-brown-light;
        cursor: pointer;

        .name {
            flex: 0;
            white-space: nowrap;
            font-size: @r18;
            color: @color-c;
        }

        .master {
            flex: 0;
            margin-left: 10px;
            font-size: @r11;
            color: @color;
            text-transform: uppercase;
            font-weight: 500;
        }

        .arrow {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            color: @color-c;

            .icon {
                font-weight: 600;
            }
        }
    }
}

input:disabled {
    color: @color-brown-light !important
}

.part_ui_textarea {
    align-self: stretch;

    textarea {
        display: block;
        font-size: @18;
        line-height: 1.5;
        color: @color-brown-light;
        padding: 0 4px;
    }
}

.elm_button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 55px;
}

.elm_button {
    display: flex;
    justify-content: center;

    button {
        max-width: 300px;
    }
}
</style>



// WEBPACK FOOTER //
// src/templates/comp/checkin-edit.vue